import PropTypes from 'prop-types';
import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import Card from '../../Card';

const messages = defineMessages({
  empty: {
    id: 'Use the sidebar to add some cards',
    defaultMessage: 'Use the sidebar to add some cards',
  },
});

const CardsBody = (props) => {
  const { data, isEditMode, isDownloadList } = props;
  const {
    cards,
    cardsPerRow = 4,
    cardsPerRowOnMobile = 1,
    align,
    label: globalLabel,
    style: globalStyle,
  } = data;
  const intl = useIntl();

  if (!cards || !cards.length) {
    return (
      <div style={{ textAlign: 'center' }}>
        {intl.formatMessage(messages.empty)}
      </div>
    );
  }

  return (
    <div className={cx('card-block', { 'download-list': isDownloadList })}>
      <div className={cx('wrap', `mobile-${cardsPerRowOnMobile}`)}>
        {cards.map((card, idx) => {
          const { icon, title, description, href } = card;

          const cardStyle = cx(`card-${cardsPerRow}`, align);

          if (!icon && !title && !description && !href && isEditMode) {
            return (
              <div className={cardStyle} key={idx}>
                <div className={'placeholder'}>
                  <div className={'phIcon'} />
                  <div className={'phTitle'} />
                  <div className={'phDesc'} />
                  <div className={'phDesc'} />
                </div>
              </div>
            );
          }

          return (
            <Card
              key={idx}
              card={card}
              isDownloadList={isDownloadList}
              data={{
                isEditMode,
                cardsPerRow,
                align,
                globalStyle,
                globalLabel,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

CardsBody.propTypes = {
  isEditMode: PropTypes.bool,
};

export default CardsBody;
